<script setup>
import PriceFormatter from '@/components/PriceFormatter.vue';
import { defineProps } from 'vue';
import {useOrderDataStore} from "@/stores/orderDataStore";
import {UseMoneyStore} from "@/stores/moneyStore";
import {useI18n} from "vue-i18n";

const orderDataStore = useOrderDataStore();
const moneyStore = UseMoneyStore();
const {t} = useI18n();

defineProps({
  refundMethod: {
    type: Object,
    required: true
  }
})

</script>

<template>
  <!-- Greece -->
  <div v-if="orderDataStore.shippingCountry==='GR'" class="mb-6">
    <label class="flex items-center">
      <input
          type="radio"
          name="how"
          id="return"
          :value="refundMethod.key"
          v-model="moneyStore.selectedHowReturnMoney"
          class="accent-bw-black mr-2"
      />
      <span class="block">{{ t('refund.title') }}</span>
    </label>
    <span class="ml-5 text-bw-lightDarkGrey italic responsive-body-xsmall block">
      ({{ t('refund.title') }} <PriceFormatter :price="orderDataStore.serviceCost.toString()" /> {{ t('offsetOnRefund') }})
    </span>
  </div>

  <!-- Cyprus -->
  <div v-else-if="orderDataStore.shippingCountry==='CY'" class="mb-6 flex place-items-center">
    <label class="flex items-center">
      <input
          type="radio"
          name="how"
          id="return"
          :value="refundMethod.key"
          :checked="moneyStore.selectedHowReturnMoney === refundMethod.key"
          v-model="moneyStore.selectedHowReturnMoney"
          class="accent-bw-black mr-2"
      />
      <span class="block">{{ t('refund.title') }}</span>
    </label>
  </div>

</template>




